/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.TEXT.PAGEHEADING,
    label: "Need support?",
    description: [
      "See the [User Guide](/assets/Self Assessment and Quality Improvement Planning Portal User Guide.pdf) for detailed steps and guidance on accessing the Self-Assessment and Quality Improvement Planning Portal platform.",
      "If your question has not been answered, please contact the Department’s Information and Enquiries service on 1800 619 113 (toll free) or at [information@earlylearningcommission.nsw.gov.au](mailto:information@earlylearningcommission.nsw.gov.au)."
    ]
  }
];